export function AccountSubmissions(guid: string): string {
	return `/v1/forms/${guid}/user-submissions`;
}

export function ActivitiesView(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/views/forms/${ID}/activities`;
}

export function Create(organizationID: number): string {
	return `/v1/organizations/${organizationID}/forms`;
}

export function CreateInvites(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/forms/${ID}/invites`;
}

export function CreateV2(organizationID: number): string {
	return `/v1/organizations/${organizationID}/forms/v2`;
}

export function DashboardView(organizationID: number): string {
	return `/v1/organizations/${organizationID}/views/forms/dashboard`;
}

export function Delete(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/forms/${ID}`;
}

export function DeleteInvites(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/forms/${ID}/invites`;
}

export function Duplicate(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/forms/${ID}/duplicate`;
}

export function Index(organizationID: number): string {
	return `/v1/organizations/${organizationID}/forms`;
}

export function InviteIndexExport(organizationID: number): string {
	return `/v1/organizations/${organizationID}/views/forms/invites/export`;
}

export function InviteIndexView(organizationID: number): string {
	return `/v1/organizations/${organizationID}/views/forms/invites`;
}

export function ListAlreadySubmittedUsers(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/forms/${ID}/already-submitted-users`;
}

export function ListConnectableChildForms(organizationID: number): string {
	return `/v1/organizations/${organizationID}/forms/connectable`;
}

export function ListInvites(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/forms/${ID}/invites`;
}

export function ManagerIndex(organizationID: number): string {
	return `/v1/organizations/${organizationID}/views/forms/manager-index`;
}

export function Orders(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/forms/${ID}/orders`;
}

export function PackagesView(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/views/forms/${ID}/packages`;
}

export function PaymentDashboardView(organizationID: number): string {
	return `/v1/organizations/${organizationID}/views/forms/dashboard-payments`;
}

export function PublicShow(guid: string): string {
	return `/v1/forms/public/${guid}`;
}

export function PublicShowV2(guid: string): string {
	return `/v1/forms/public-v2/${guid}`;
}

export function Reactivate(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/forms/${ID}/reactivate`;
}

export function Show(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/forms/${ID}`;
}

export function SubmittableAccounts(guid: string): string {
	return `/v1/forms/${guid}/submittable-accounts`;
}

export function Summary(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/forms/${ID}/summary`;
}

export function TeamInvitationManagerIndex(organizationID: number): string {
	return `/v1/organizations/${organizationID}/views/forms/manager-index/team-invitation`;
}

export function TeamInvitationManagerShow(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/forms/${ID}/team-invitation`;
}

export function TeamInvitationTeams(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/forms/${ID}/team-invitation-teams`;
}

export function TeamInvitationUsers(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/forms/${ID}/team-invitation-users`;
}

export function UnauthenticatedPublicShow(guid: string): string {
	return `/v1/forms/unauthed/${guid}`;
}

export function Update(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/forms/${ID}`;
}

export function UpdateInvites(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/forms/${ID}/invites`;
}

export function UpdateV2(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/forms/${ID}/v2`;
}

export function UserData(guid: string, ID: number): string {
	return `/v1/forms/${guid}/user-submission-data/${ID}`;
}

